import { createActions } from 'redux-actions';

const satisfactionActions = createActions(
  'GET_AVAILABLE_SATISFACTION_LANGUAGES_REQUEST',
  'GET_AVAILABLE_SATISFACTION_LANGUAGES_REQUEST_SUCCEEDED',
  'GET_AVAILABLE_SATISFACTION_LANGUAGES_REQUEST_FAILED',

  'CHANGE_SATISFACTION_LANGUAGE_REQUEST',
  'CHANGE_SATISFACTION_LANGUAGE_REQUEST_SUCCEEDED',
  'CHANGE_SATISFACTION_LANGUAGE_REQUEST_FAILED',

  'CANCEL_SATISFACTION_REQUEST',
  'CANCEL_SATISFACTION_REQUEST_SUCCEEDED',
  'CANCEL_SATISFACTION_REQUEST_FAILED',
);

export { satisfactionActions };
